import { solidstate, type _SolidState } from ":setup/qstate";
import { For, Match, Show, Switch, createMemo } from "solid-js";
import { global } from ":shared/app";
//
import { Information } from "./informtion";
import { Scoring } from "./scoring";
import type { GradingData, TeamData } from "../../_model";

export type Props = {
  data: _SolidState.State<GradingData>; //<model.eval.EvaluatorData["teams"][0]>;
  idx: number;
  onSubmit: (props: { team: TeamData; scores: Record<string, number> }) => Promise<TeamData>;
};
const tabs = ["info", "score"] as const;
export default function EvaluationModal(props: Props) {
  const active_idx = solidstate.create(props.idx);
  const entity = createMemo(() => props.data.value.teams[active_idx.value]);
  const $breakpoint = global.store.hooks.dom.useDedicatedBreakpoints("xs", "sm", "md", "lg");
  const $tab = solidstate.create(tabs[0] as (typeof tabs)[number]);
  const $hide_prev_next = solidstate.create(false);

  function switchEntity(next: boolean) {
    const arr_length = props.data.value.teams.length;
    let idx = active_idx.value;
    if (next) {
      idx++;
      if (idx >= arr_length) idx = 0;
    } else {
      idx--;
      if (idx <= -1) idx = arr_length - 1;
    }
    active_idx.set(idx);
    $tab.set("info");
  }

  async function onSubmit(p: { scores: Record<string, number> }) {
    const scores = p.scores;
    const team = entity();
    return props.onSubmit({ team, scores }).then((new_team) => {
      global.store.actions.toast.pushToast({
        type: "success",
        message: "Evaluation Submitted!",
      });
      props.data.set((s) => {
        const teams = [...s.teams];
        let history = [...s.history];
        if (!history.includes(new_team.id)) {
          history = [...history, new_team.id];
        }
        teams[active_idx.value] = new_team;
        return { ...s, history, teams };
      });
    });
  }

  return (
    <Switch>
      <Match when={$breakpoint("xs", "sm")}>
        <section class="grid grid-rows-[0.1fr_1fr_0.1fr] w-full h-full gap-2 overflow-hidden children:(overflow-hidden)">
          <div class="flex flex-row w-full h-fit items-center gap-x-2">
            <For each={tabs}>
              {(item, index) => {
                return (
                  <p
                    //
                    onclick={() => $tab.set(item)}
                    class={`
                      w-full capitalize text-center text-0.8rem py-0.5 border-b-2 border-solid
                      ${$tab.value === item ? "text-brand border-brand" : "text-text-alt border-text-alt"}
                    `}
                  >
                    {item}
                  </p>
                );
              }}
            </For>
          </div>
          <div class="flex flex-col w-full h-full my-1">
            <Switch>
              <Match when={$tab.value === "info"}>
                <Information
                  entity={entity()}
                  onUrl={(show) => {
                    $hide_prev_next.set(show);
                  }}
                />
              </Match>
              <Match when={$tab.value === "score"}>
                <Scoring
                  data={props.data?.value}
                  entity={entity()}
                  onSubmit={onSubmit}
                  onNext={() => switchEntity(true)}
                />
              </Match>
            </Switch>
          </div>
          <Show when={!$hide_prev_next.value}>
            <div class="grid grid-cols-2 w-full h-full gap-x-2 content-end children:(!h-40px !bg-bg-alt !text-text)">
              <button class="form-btn" onClick={() => switchEntity(false)}>
                Previous
              </button>
              <button class="form-btn" onClick={() => switchEntity(true)}>
                Next
              </button>
            </div>
          </Show>
        </section>
      </Match>
      <Match when={true}>
        <section class="grid grid-cols-[1fr_0.45fr] w-full h-full gap-x-2 py-2 overflow-hidden">
          <Information entity={entity()} />
          <div class="grid grid-cols-1 grid-rows-[1fr_5%] w-full h-full gap-2 overflow-hidden">
            <Scoring data={props.data?.value} entity={entity()} onSubmit={onSubmit} onNext={() => switchEntity(true)} />
            <div class="grid grid-cols-2 w-full h-full gap-x-2 content-end children:(!h-40px !bg-bg-alt !text-text)">
              <button class="form-btn" onClick={() => switchEntity(false)}>
                Previous
              </button>
              <button class="form-btn" onClick={() => switchEntity(true)}>
                Next
              </button>
            </div>
          </div>
        </section>
      </Match>
    </Switch>
  );
}
